import type { CountryConfig } from './typing';

export const statements: CountryConfig = {
    enabled: true,
    createStatement: true,
    deliveryDefinitions: {
        distribution: ['GEORGE', 'GEORGE_AND_EMAIL'],
        format: ['PDF_A4', 'XML_SEPA', 'TXT_MT940'],
        periodicity: ['DAILY', 'MONTHLY', 'YEARLY'],
        canCreateDefinition: true,
        statementNumberEditable: true,
    },
    showMultiDownloadCard: true,
    showNewCustomStatementCard: true,
    tableColumns: [
        { id: 'description', label: 'main.settings.name', width: '45%' },
        { id: 'time-span', label: 'account.statements.timeFrame', width: '40%' },
        { id: 'format', label: 'account.statements.statementFormat', width: '15%' },
        { id: 'download', label: 'app.download', width: '10%' },
    ],
};
